import {
  put, all, call, select, takeEvery,
} from 'redux-saga/effects';
import { getCurrentAuthHeader } from 'domain/fuse/auth/utils';
import * as I18n from 'circe/I18n';
import { exception } from 'circe/logger';
import { show as showNotification } from 'circe/notifications/actions';
import { FORM_NAME } from 'domain/shipment/batchOrders/fuse/Forms/BatchOrders/constants';
import { startSubmit, stopSubmit } from 'circe/forms/actions';
import { getCurrentProfile } from 'domain/fuse/auth/selectors';
import { batchSalesOrders, batchedSuccessfully, batchedSalesOrders } from './actions';
import * as api from './api';
import { toggleBatchingScreen } from '../actions';
import { ASSIGN_ORDERS_FORM_NAME } from '../constants';

function* doBatchSalesOrders(context, action) {
  const { payload } = action;

  const { values } = payload;

  const { salesOrders, batchRequestType, selectedFleet } = values;

  let resp;
  try {
    yield put(startSubmit(FORM_NAME));

    const state = yield select();
    const headers = yield call(getCurrentAuthHeader, state);

    const formData = new FormData();

    formData.append('file', salesOrders[0]);
    formData.append('batchRequestType', batchRequestType);
    formData.append('fleetId', selectedFleet ? selectedFleet.account : null);

    resp = yield call(api.batchSalesOrders, formData, headers);
    yield put(batchedSalesOrders(resp));
    if (!resp.success) {
      throw new Error('Unable to batch sales orders.');
    }

    yield put(toggleBatchingScreen());
    yield put(batchedSuccessfully());
    yield put(
      showNotification(
        I18n.str('salesOrdersBatchedSuccessfully', 'Sales orders were batched successfully.'),
        'success',
      ),
    );
  } catch (error) {
    yield put(batchedSalesOrders(resp));
    yield put(stopSubmit(ASSIGN_ORDERS_FORM_NAME));
    yield put(toggleBatchingScreen());
    yield put(batchedSuccessfully());
    if (resp && !resp.response) {
      yield put(
        showNotification(
          I18n.str('uploadBatchSalesOrders', 'Unable to batch sales orders.'),
          'error',
        ),
      );
    } else if (resp && resp.response) {
      yield put(
        showNotification(
          I18n.str('salesOrdersBatchedSuccessfully', 'Sales orders were batched successfully.'),
          'success',
        ),
      );
    } else {
      yield put(
        showNotification(
          I18n.str('uploadBatchSalesOrders', 'Unable to batch sales orders.'),
          'error',
        ),
      );
    }
    exception(error);
  }
}

function* watcher(context) {
  yield all([takeEvery(batchSalesOrders().type, doBatchSalesOrders, context)]);
}

export default watcher;
